import { Component, type ReactNode } from 'react';
import { PaletteEditor } from '../components/PaletteEditor';
import { useColorContext } from '../contexts/ColorContext';

interface ErrorState {
  hasError: boolean;
  error: Error | null;
}

class PaletteErrorBoundary extends Component<{ children: ReactNode }, ErrorState> {
  state: ErrorState = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '48px 24px', textAlign: 'center', color: 'var(--ink-2)', fontSize: 13 }}>
          <h3 style={{ color: 'var(--ink)', fontSize: 18, marginBottom: 8, fontWeight: 600 }}>
            Palette Editor failed to load
          </h3>
          <p style={{ marginBottom: 12 }}>
            This is likely a dependency version mismatch with @dnd-kit.
          </p>
          <pre style={{
            padding: '12px',
            background: 'var(--panel)',
            border: '1px solid var(--line)',
            borderRadius: 'var(--radius-lg)',
            fontSize: 11,
            textAlign: 'left',
            maxWidth: 600,
            margin: '0 auto',
            overflow: 'auto',
            fontFamily: 'var(--font-mono)',
          }}>
            {this.state.error?.message}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

export function PaletteTool() {
  const { result } = useColorContext();
  return (
    <PaletteErrorBoundary>
      <PaletteEditor contextHex={result?.hex} />
    </PaletteErrorBoundary>
  );
}
